import { RegistrationMode } from '@easeltv/client-sdk';
import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import AppConsent from '../components/Modal/AppConsent';
import PairingTemplate from '../components/Templates/PairingTemplate';
import SignInTemplate from '../components/Templates/SignInTemplate';
import { useConfig } from '../hooks/useConfig/useConfig';
import { AuthRoute } from './routes';

/* ---------------------------------- Pages --------------------------------- */

const PaymentHandoffTemplate = lazy(
    () => import('../components/Templates/PaymentHandoffTemplate'),
);

/* --------------------------------- Routes --------------------------------- */

const MicrositeRoutes = () => {
    const {
        registration: { mode },
    } = useConfig();

    const showPairing =
        mode !== RegistrationMode.Disabled &&
        mode !== RegistrationMode.InviteOnly;

    return (
        <>
            <AppConsent />
            <Routes>
                {showPairing && (
                    <>
                        <Route
                            path="/pair"
                            element={
                                <Suspense fallback={null}>
                                    <PairingTemplate />
                                </Suspense>
                            }
                        />
                        <Route
                            path="/pair/:pairingCode"
                            element={
                                <Suspense fallback={null}>
                                    <PairingTemplate />
                                </Suspense>
                            }
                        />
                    </>
                )}
                <Route
                    path="/signin"
                    element={
                        <AuthRoute>
                            <Suspense fallback={null}>
                                <SignInTemplate disableRegistration />
                            </Suspense>
                        </AuthRoute>
                    }
                />
                <Route
                    path="/"
                    element={
                        <Suspense fallback={null}>
                            <PaymentHandoffTemplate />
                        </Suspense>
                    }
                />
                <Route
                    path="/:code"
                    element={
                        <Suspense fallback={null}>
                            <PaymentHandoffTemplate />
                        </Suspense>
                    }
                />
                <Route path="*" element={<Navigate replace to="/" />} />
            </Routes>
        </>
    );
};

/* --------------------------------- Export --------------------------------- */

export default MicrositeRoutes;
